





































import {
  Vue,
  Component,
} from "@/shared/vuepack";
import {
  CampaignDecision,
} from "@/shared/types";
import moment from "moment";
import HsabLoginWrapper from "@/shared/components/ui/HsabLoginWrapper.vue";
import { EbtoTransferProcess } from "@/employee/route-names";
import SendConfirmationEmail from "./SendConfirmationEmail.vue";
import { useEbtoStore } from "@/shared/store/ebto";

@Component({
  components: {
    HsabLoginWrapper,
    SendConfirmationEmail
  }
})
export default class Retained extends Vue {
  ebtoStore = useEbtoStore();

  EbtoTransferProcess = EbtoTransferProcess;
  decision = CampaignDecision.Stay;

  moment = moment;

  get changeMindDate (): string {
    if (!this.ebtoStore.electionEnd) {
      return "";
    }
    return moment.utc(this.ebtoStore.electionEnd).format("LL");
  }
}
